import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WebNavigationService} from '../../navigation.service';

@Component({
  selector: 'app-payment-option',
  templateUrl: './payment-option.component.html',
  styleUrls: ['./payment-option.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PaymentOptionComponent implements OnInit {

  constructor(private navigationService: WebNavigationService) {
  }

  ngOnInit() {
  }

  get selectedOption() {
    return this.navigationService.selectedOption;
  }

  get expanded() {
    return this.navigationService.expanded;
  }

  get expandPayments() {
    return this.navigationService.expandPayments;
  }

  selectOption(option) {
    this.navigationService.selectOption(option);
  }

  selectPaymentsOption(conciliacionOption) {
    this.navigationService.selectConciliacionOption(conciliacionOption);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src14910448/src/src/app/components/navigation/options/payments/payment-option.component.ts